// Breakpoints para media queries (responsivos)
// Usado por: store (app.js) y main.js para inicializar listeners de media queries
export const BREAKPOINT_MEDIAS = [1024, 1650]
